export const SET_WINDOW_INFO = 'alert-modal/SET_WINDOW_INFO';
export const setWindowInfoAction = payload => ({
	type: SET_WINDOW_INFO,
	payload,
});
